<template>
  <div class="blog-page">
    <div class="blog-header">
      <h1>{{ $t('blog.title') }}</h1>
      <p>{{ $t('blog.subtitle') }}</p>
    </div>

    <div class="blog-list">
      <article 
        class="blog-card" 
        v-for="article in articles" 
        :key="article.id"
        @click="$router.push('/blog/' + article.id)"
      >
        <div class="blog-card-content">
          <div class="blog-meta">
            <span class="blog-category">{{ $t('blog.articles.' + article.id + '.category') }}</span>
            <span class="blog-date">{{ $t('blog.articles.' + article.id + '.date') }}</span>
          </div>
          <h2>{{ $t('blog.articles.' + article.id + '.title') }}</h2>
          <p>{{ $t('blog.articles.' + article.id + '.summary') }}</p>
          <div class="blog-footer">
            <span class="read-more">{{ $t('blog.readMore') }} →</span>
            <span class="read-time">{{ $t('blog.articles.' + article.id + '.readTime') }}</span>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogList',
  data() {
    return {
      articles: [
        { id: 'json-guide' },
        { id: 'timestamp-explained' },
        { id: 'mortgage-tips' },
        { id: 'markdown-writing' },
        { id: 'image-optimization' }
      ]
    }
  }
}
</script>

<style scoped>
.blog-page {
  max-width: 800px;
  margin: 0 auto;
}

.blog-header {
  text-align: center;
  margin-bottom: 40px;
}

.blog-header h1 {
  font-size: 32px;
  margin-bottom: 12px;
  color: var(--text-primary);
}

.blog-header p {
  color: var(--text-secondary);
  font-size: 16px;
}

.blog-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.blog-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 28px 32px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: var(--shadow-sm);
}

.blog-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: var(--accent-color);
}

.blog-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.blog-category {
  background: var(--accent-light);
  color: var(--accent-color);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.blog-date {
  color: var(--text-muted);
  font-size: 13px;
}

.blog-card h2 {
  font-size: 20px;
  color: var(--text-primary);
  margin-bottom: 10px;
  line-height: 1.4;
}

.blog-card p {
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.7;
  margin-bottom: 16px;
}

.blog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.read-more {
  color: var(--accent-color);
  font-size: 14px;
  font-weight: 600;
}

.read-time {
  color: var(--text-muted);
  font-size: 13px;
}

@media (max-width: 768px) {
  .blog-card {
    padding: 20px 24px;
  }

  .blog-card h2 {
    font-size: 18px;
  }
}
</style>
